import React, { useMemo } from 'react'
import { Tab, Tabs } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ArrowForward } from '@mui/icons-material'

import './SearchTabs.less'
import { setActiveTab } from '../Store/SearchSlice'
import { useAppDispatch, useAppSelector } from '../hooks'
import { hasDefinitions } from '../Utilities/queryLinks'


const SearchTabs = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const activeTab = useAppSelector(state => state.search.activeTab)
  const source = useAppSelector(state => state.search.currentSearch?.source || '')
  const target = useAppSelector(state => state.search.currentSearch?.target || '')


  const showSourceDefinitions = useMemo(() => hasDefinitions(source), [source])
  const showTargetDefinitions = useMemo(() => hasDefinitions(target), [target])

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    dispatch(setActiveTab(newValue))
  }

  return (
    <>{source &&
      <Tabs value={activeTab} onChange={handleChange} className="search-tabs">
        <Tab label={<>{source.toUpperCase()}<ArrowForward />{target.toUpperCase()}</>} value="dictionaries" />
        {showSourceDefinitions && <Tab label={t('tools', {'language': source.toUpperCase()})} value="definitions-source" />}
        {showTargetDefinitions && <Tab label={t('tools', {'language': target.toUpperCase()})} value="definitions-target" />}
      </Tabs>
    }
    </>
  )
}

export default SearchTabs